import type { SVGProps } from 'react';
const SvgHorizontalSplit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#horizontal_split_svg__a)">
      <path
        fill="currentColor"
        d="M3 19h18v-6H3v6Zm0-8h18V9H3v2Zm0-6v2h18V5H3Z"
      />
    </g>
    <defs>
      <clipPath id="horizontal_split_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHorizontalSplit;
